module.exports = [{"name":"2017 1st overall","henri":9.2,"cap":0,"surplus":9.2},{"name":"2017 32st overall","henri":6.2,"cap":0,"surplus":6.2},{"name":"2017 64th overall","henri":4.2,"cap":0,"surplus":4.2},{"name":"2017 97th overall","henri":2.2,"cap":0,"surplus":2.2}]


//////////////////
// WEBPACK FOOTER
// ./src/Mock/trade-team-one-picks.json
// module id = 1410
// module chunks = 0